
export class VisitorManagementListenerContext {
    constructor() {

    }
}
